import CONFIG from '@/./config'

/**
 * Da mehr als eine Anwendungen unter der gleichen Domain laufen, müssen alle Storage-Verwendungen,
 * die einen Key beinhalten (setItem, getItem usw.), über diese Klasse gewrappt werden.
 */
class StorageWrapperFactory {
  constructor (storage) {
    this._storage = storage
  }

  get wrapper () {
    const me = this
    return {
      setItem (key, value) {
        me._storage.setItem(CONFIG.key + '-' + key, value)
      },
      getItem (key) {
        return me._storage.getItem(CONFIG.key + '-' + key)
      },
      removeItem (key) {
        return me._storage.removeItem(CONFIG.key + '-' + key)
      },
      clear () {
        me._storage.clear()
      }
    }
  }
}

export const LOCAL_STORAGE_WRAPPER = new StorageWrapperFactory(localStorage)
  .wrapper
